export default __webpack_public_path__ + "static/media/meals_female@3x.ae778c48.png";